<template>
    <div>
        <ShowQuestion
            :sort-order="sortOrder"
            :text="text"
            :is-required="isRequired"
            :type="type"
            :desktop-image-url="desktopImageUrl"
            :mobile-image-url="mobileImageUrl"
            v-if="!showEdit"
        />
        <EditQuestion
            v-else
            :initial-is-required="isRequired"
            :initial-text="text"
            :initial-sort-order="sortOrder"
            :initial-type="type"
            :desktop-image-url="desktopImageUrl"
            :mobile-image-url="mobileImageUrl"
            @question-updated="handleQuestionUpdate"
            @delete-question-image="handleDeleteQuestionImage"
            @closed="showEdit = false"
        />

        <div v-if="!showEdit">
            <button :disabled="isSurveyActive" @click="removeQuestion" class="btn btn-danger mt-3">
                <i class="fa fa-trash"/>
                <span>{{ _t('Delete question') }}</span>
            </button>
            <button :disabled="isSurveyActive" class="btn btn-warning" @click="showEdit = true">{{
                    _t("Edit")
                }}
            </button>
        </div>

    </div>
</template>

<script>
import ShowQuestion from "./ShowQuestion";
import EditQuestion from "./EditQuestion";
import Swal from "sweetalert2";

export default {
    name: "Question",
    components: {EditQuestion, ShowQuestion},
    props: [
        'text',
        'type',
        'sortOrder',
        'isRequired',
        'questionId',
        'surveyId',
        'isSurveyActive',
        'desktopImageUrl',
        'mobileImageUrl',
    ],
    data() {
        return {
            showEdit: false,
        }
    },
    methods: {
        removeQuestion() {
            let that = this;
            Swal.fire({
                text: _t('delete_question_confirmation-form-label'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                cancelButtonClass: "btn btn-default",
                confirmButtonText: _t('Yes'),
                confirmButtonClass: "btn btn-success",
            })
                .then(function (result) {
                    if (!result.isConfirmed) return;
                    axios.delete(`/survey/${that.surveyId}/questions/${that.questionId}`)
                        .then((res) => {
                            that.$emit('question-removed')
                            Swal.fire({
                                text: _t("Question removed successfully!"),
                                icon: "success",
                                duration: '1000'
                            })
                        })
                        .catch((err) => {
                            console.log(err)
                            Swal.fire({
                                text: err.response.data.message || 'Something went wrong',
                                icon: "error",
                                duration: '1000'
                            })
                        });
                });
        },
        handleQuestionUpdate(data) {
            console.log(data);
            const formData = new FormData();
            formData.append('text', data.text);
            formData.append('type', data.type);
            formData.append('sort_order', data.sort_order);
            formData.append('is_required', (data.is_required ? 1 : 0));
            if (data.desktop_image)
                formData.append('desktop_image', data.desktop_image);
            if (data.mobile_image)
                formData.append('mobile_image', data.mobile_image);
            formData.append('_method', 'PUT');

            axios.post(`/survey/${this.surveyId}/questions/${this.questionId}`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                .then((res) => {
                    this.$emit('question-updated')
                    this.showEdit = false;

                    Swal.fire({
                        text: _t("Question updated successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    console.log(err)
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });
        },
        handleDeleteQuestionImage(data) {
            let type = data.type;
            let Instance = this;
            Swal.fire({
                text: _t('Are you sure you want to delete ' + type + ' image?'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                confirmButtonText: _t('Delete'),
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-default',
                }
            }).then(function (result) {
                if (result.isConfirmed) {
                    axios.delete(`/survey/${Instance.surveyId}/questions/${Instance.questionId}/delete-image?type=${type}`)
                        .then((res) => {
                            Instance.$emit('question-updated')
                            Instance.showEdit = false;

                            Swal.fire({
                                text: _t("Image deleted!"),
                                icon: "success",
                                duration: '1000'
                            })
                        })
                        .catch((err) => {
                            console.log(err)
                            Swal.fire({
                                text: err.response.data.message || 'Something went wrong',
                                icon: "error",
                                duration: '1000'
                            })
                        });
                }
            });


            console.log(data);
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/Question.vue